import { BindParams, RootStore } from '@/components/DonationForm/types';
import { ComponentIds as Ids } from '@/components/DonationForm/constants';

const bindCoverFees = (rootStore: RootStore): BindParams => {
  const { $state, localeKeys } = rootStore;

  return {
    [Ids.CoverFeesCheckbox]: {
      deleted: () => !$state.isCoverFeesEnabled,
      checked: () => $state.isCoverFeeChecked,
      label: () =>
        localeKeys.donations.widget.coverFees.text({
          feeAmount: $state.currencyFormatter($state.calculatedFee),
        }),
      onChange: ({ target: { checked } }) => {
        $state.userInputCoverFees = checked;
      },
    },
  };
};

export default bindCoverFees;
